import React from "react";

function AccordionItem({ question, children, defaultOpen = false }) {
  const [open, setOpen] = React.useState(defaultOpen);
  const contentRef = React.useRef(null);

  return (
    <div className={"accordion-item" + (open ? " accordion-item-open" : "")}>
      <button
        type="button"
        className="accordion-trigger"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        <span>{question}</span>
        <span className="accordion-icon" aria-hidden="true">{open ? "−" : "+"}</span>
      </button>
      <div
        className="accordion-panel"
        style={{ maxHeight: open ? contentRef.current?.scrollHeight + "px" : "0px" }}
      >
        <div className="accordion-panel-inner" ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
}

function Accordion({ children }) {
  return <div className="accordion">{children}</div>;
}

Accordion.Item = AccordionItem;

export default Accordion;
